import React, { Component }       from "react";
import { FormGroup, FormControl, ControlLabel, DropdownButton, MenuItem, OverlayTrigger, Tooltip } from "react-bootstrap";
import LoaderButton               from "../../components/LoaderButton";
import uniqueId                   from 'lodash/uniqueId';
import { FontAwesomeIcon }        from '@fortawesome/react-fontawesome'
import { library }                   from '@fortawesome/fontawesome-svg-core'
import { faPlus, faCopy, faTimes }       from '@fortawesome/free-solid-svg-icons'
import { faCircle }              from '@fortawesome/free-regular-svg-icons'
import CreateMonthViewDayBlockRow from "./CreateMonthViewDayBlockRow";
import Sortable                   from 'react-sortablejs';
//import SortableList from "../components/SortableList";

export default class CreateMonthViewDay extends Component {
    constructor(props) {
        super(props);

        this.state = {
            days: {},
            day_ids: {},
            week_id: null,
            total_week_days: 0,
            current_week: null,
            block_arr: []
        }
        this.getProgramDOMTree = this.getProgramDOMTree.bind(this)
        this.deleteBlock    = this.deleteBlock.bind(this);
        this.duplicateBlock = this.duplicateBlock.bind(this);
        this.updateBlockData= this.updateBlockData.bind(this);
        this.openAddNewExerciseModal = this.openAddNewExerciseModal.bind(this);
        this.editMonthViewExercise   = this.editMonthViewExercise.bind(this);
    }

    componentDidMount() {
        this.setState({
            program_block: this.props.program_block,
            week_id:       this.props.week_id,
            current_week:  this.props.current_week,
            days:          this.props.days,
            day_id:        this.props.day_id,
            day_ids:       this.props.day_ids,
            total_week_days: this.props.total_week_days,
            completedDayIds: this.props.completedDayIds
        });

    }

    componentWillReceiveProps(nextProps) {
        //console.log("--------- CREATE DAY RECEIVED PROPS!!! ");
        this.setState({
            program_block:   nextProps.program_block,
            week_id:         nextProps.week_id,
            current_week:    nextProps.current_week,
            days:            nextProps.days,
            day_id:          nextProps.day_id,
            day_ids:         nextProps.day_ids,
            total_week_days: nextProps.total_week_days,
            completedDayIds: nextProps.completedDayIds
        });
    }

    getSingleBlockRowData (value, index, name, day_id, day_num, week_num, week_id, block_id, advanced) {
            var data = value ? this.renderExerciseRowData(index, value.exercise) : null;

            return data;
    }

    //// EXERCISE ROW FUNCTION ////
    renderExerciseRowData(block_index, exercise) {
        var exercise_row = "";
        var ctr = 0;
        var temp;
        var tmp_arr = [];
        for(var key in exercise) {
            var value = exercise[key];

            var exericse_row = Object.keys(exercise).map( index => {
                var exercise_id         = exercise[index].id;
                var exercise_name       = exercise[index].name;
                var notes               = exercise[index].notes;
                var advanced_view       = exercise[index].advanced_view;
                var advanced_metrics    = null;
                var modal_simple_action = "edit"; // edit modal data
                var exercise_details    = "";//<span className="extendExerciseContainer" style={{display: this.state.showExerciseDetailRow}}>{ details }</span>

                if(exercise_name) {
                    var exercise_data = parseInt(index)+1 + ". " + exercise_name;
                    tmp_arr.push(exercise_data);
                }
            })
        }
        return tmp_arr;
    }
    //// END SINGLE BLOCK ROW DATA ////
    ///////////////////////////////////

    /*getDayFromMonthView = (day_id, day_num, curr_week, week_id) => {
        this.props.getDayFromMonthView(day_id, day_num, curr_week, week_id)
    }*/

    getProgramDOMTree = (last_exercise_in_block, error_code) => {
        this.props.getProgramDOMTree(last_exercise_in_block, error_code);
    }

    openAddNewExerciseModal = (block_index, day_id, block_id) => {
        this.props.openAddNewExerciseModal(block_index, day_id, block_id);
    }

    editMonthViewExercise = (day_id, block_index, block_id, set_id, ex_id, ex_order, ex_name) => {
        this.props.editMonthViewExercise(day_id, block_index, block_id, set_id, ex_id, ex_order, ex_name);
    }

    duplicateBlock = (index, week_id, day_id, block_id, total_blocks, block_name) => {
        this.props.duplicateBlock(index, week_id, day_id, block_id, total_blocks, block_name);
    }

    duplicateBlock = (index, week_id, day_id, block_id, total_blocks, block_name) => {
        this.props.duplicateBlock(index, week_id, day_id, block_id, total_blocks, block_name);
    }

    deleteBlock = (index, day_id, block_id) => {
        this.props.deleteBlock(index, day_id, block_id);
    }

    updateBlockData (blocks_order, block_id, day_id, day_id_to, block_to_index) {
        this.props.sortBlock(blocks_order, block_id, day_id, day_id_to, block_to_index);
    }

    checkNumberOfBlocksInDay = (day_id_from) => {
        var programObj = this.state.program_block;
        var block_ctr = 0;
        for(var key in programObj) {
            var value        = programObj[key];
            var day_id       = value.day_id;
            if(day_id === day_id_from) {
                block_ctr++;
            }
        }
        return block_ctr;
    }

    render() {
        //console.log("*** RENDER CREATE DAY ***");
        var that = this;
        var exercise_name;
        var program_block   = this.state.program_block;
        var day_id          = this.state.day_id;
        var days            = this.state.days;
        var day_ids         = this.state.day_ids;
        var week_id         = this.state.week_id;
        var current_week    = this.state.current_week;
        var total_week_days = this.state.total_week_days;

        var total_blocks_ctr   = 0;

        //console.log("Number of days: " + Object.keys(days).length);

        // Change Y Position of "+ Add Block" btn //
        var day_container_scroll_height = 339;
        var week_box_height    = this.props.week_box_height;

        if(week_box_height === 720) {
            day_container_scroll_height = 630;
        } else if(week_box_height === 560) {
            day_container_scroll_height = 470;
        } else if(week_box_height === 400) {
            day_container_scroll_height = 300;
        }

        var total_days     =  Object.keys(days).map(function (key0, index) {
            var day_num    = parseInt(index) + 1;
            var day_id     = day_ids[index];
            var block_obj  = {};
            var parent_arr = [];

            //console.log("*** day_id: " + day_id);
            for(var key in program_block) {

                var value       = program_block[key];
                var day_id_tmp  = value.day_id;
                var day_order   = value.day_order;
                var block_order = value.block_order;
                var block_name  = value.block_name;
                var block_id    = value.block_id;
                var exercise    = value.exercise;
                var exer_lgth   = value.exercise_lgth;

                if(block_name === null) block_name = "";
                if(block_name != null) {
                    if(day_id === day_id_tmp) {
                            /// BEGIN: GET EXERCISES!!! ///
                            var title = "Block " + index + ".";

                            var exercise_obj = {};
                            for(var key in exercise) {
                                var exercise_name   = exercise[key].name;
                                var exercise_id     = exercise[key].id;
                                var set_id          = exercise[key].set_id;
                                var exercise_order  = exercise[key].order;
                                var exercise_notes   = exercise[key].notes;
                                //console.log("exercise_name: " + exercise_name);
                                exercise_obj[key] = {
                                    set_id: set_id,
                                    exercise_name: exercise_name,
                                    exercise_id: exercise_id,
                                    exercise_order: exercise_order,
                                    exercise_notes: exercise_notes
                                }
                            }

                            block_obj = {
                                value: value,
                                day_id: day_id_tmp,
                                block_id: block_id,
                                block_name: block_name,
                                block_number: total_blocks_ctr,
                                block_order: block_order,
                                week_id: week_id,
                                exercises: exercise_obj // add exercise props
                            };

                        parent_arr.push(block_obj);

                    }
                }
            }

            ////  DAY CARD OVERLAY; IF DAY ID HAS BEEN COMPLETED ON ATHLETE SIDE, ADD OVERLAY  ////
            var completed_day_ids = that.state.completedDayIds;
            var day_completed     = false;

            // Does day id exits in array, if so the day was completed by the athlete already
            if(completed_day_ids != undefined) {
                var day_completed_arr = completed_day_ids.indexOf(day_id);
                if(day_completed_arr != -1) day_completed = true;
            }

            var card_overlay;
            var left_xpos = 10;

            if(day_completed) {
                ////  Below can't be a dynamic statement since the daycards are laid out unvenly across the x-axis  ////
                if(day_num == 2) left_xpos = 325;
                else if(day_num == 2) left_xpos = 325;
                else if(day_num == 3) left_xpos = 645;
                else if(day_num == 4) left_xpos = 965;
                else if(day_num == 5) left_xpos = 1285;
                else if(day_num == 6) left_xpos = 1605;
                else if(day_num == 7) left_xpos = 1925;
                card_overlay = <span style={{float:"right", position:"absolute", left:left_xpos, top:50,  zIndex:1010}}>
                                    <span style={{float:"left", position:"absolute", textAlign:"center", top:140, left:37, fontSize:24, color:"white", fontWeight: 600, zIndex:1200}}>
                                        THE MEMBER HAS<br/>
                                        COMPLETED THIS DAY
                                    </span>
                                    <div style={{width:278, height:635, backgroundColor: "#000", opacity:.5}} />
                               </span>
            }

            return   <React.Fragment key={uniqueId()}>
                        <span className="weekMainSingleDay"
                              style={{height:day_container_scroll_height}}
                              key={index}
                              week_num = { current_week }
                              week_id = { week_id }
                              day_id  = { day_id }
                              data-id = { day_id /*+"|"+week_id*/ }
                        >
                                <div className="viewDayLink weekMainSingleDayTitle"
                                     day_id  = { day_id }
                                     week_id = { week_id }
                                     onClick={ () => that.props.getDayFromMonthView(day_id, day_num, current_week, week_id)}
                                >
                                         <div className="monthViewDayHeaderContainer" >
                                             <div className="monthViewDayCardHeader">
                                                  DAY { day_num } { /* day_id /* */ } <span className = "glyphicon glyphicon-pencil" style={{paddingLeft:5, opacity: .7, fontSize:18}}/>
                                             </div>
                                             <span className="createMonthViewDay_copyDeleteContainer ">
                                                     <OverlayTrigger key       = {uniqueId()}  placement = "top"
                                                             overlay={<Tooltip id = "top" style={{fontSize:16}}>Add Block</Tooltip>}
                                                     >
                                                           <span>
                                                               {/* <span className = "createMonthViewDay_addBox"
                                                                      onClick={(e) => {e.stopPropagation(); that.props.duplicateDay(week_id, day_id, days.length)}}>
                                                                       <FontAwesomeIcon icon={faPlus}
                                                                                        className = "createMonthViewDay_faPlus"/>

                                                                       <FontAwesomeIcon icon={faCircle}
                                                                                        className = "createMonthViewDay_faCircle"/>
                                                                </span> */ }
                                                                   <FontAwesomeIcon icon={faCircle}
                                                                                     className = "createMonthViewNewBlock_faCircle"/>
                                                                   <DropdownButton bsSize    = "large"
                                                                                   pullRight
                                                                                   //onSelect  = {(event) => this.onSelect(event)}
                                                                                   title     = ""
                                                                                   className = "glyphicon glyphicon-plus pull-right weekMainSingleDayEditIcons3"
                                                                                   onClick   = {(e) => {e.stopPropagation()}}
                                                                                   style     = {{fontSize:18, color:"#999", outline:"none", boxShadow: "none", backgroundColor: "transparent"}}
                                                                                   id        = "dropdown-size-large">

                                                                             <MenuItem className="dropdownMenuItem"
                                                                                         onClick={(e) => {e.stopPropagation(); that.props.addBlock("addMonthViewBlock", day_id)}}>
                                                                                 New Block
                                                                             </MenuItem>
                                                                             <MenuItem divider />
                                                                             <MenuItem className="dropdownMenuItem"
                                                                                         onClick={(e) => {e.stopPropagation(); that.props.addFreeFormBlock("addMonthViewBlock", day_id)}}>
                                                                                 Free-Form Block
                                                                             </MenuItem>
                                                                   </DropdownButton>
                                                           </span>
                                                    </OverlayTrigger>

                                                     <OverlayTrigger key       = {uniqueId()}  placement = "top"
                                                             overlay={<Tooltip id = "top" style={{fontSize:16}}>Duplicate Day</Tooltip>}
                                                     >
                                                           <span className = "createMonthViewDay_copyBox"
                                                                 onClick={(e) => {e.stopPropagation(); that.props.duplicateDay(week_id, day_id, days.length)}}>
                                                                  <FontAwesomeIcon icon={faCopy}
                                                                                   className = "createMonthViewDay_faCopy"/>

                                                                  <FontAwesomeIcon icon={faCircle}
                                                                                   className = "createMonthViewDay_faCircle"/>
                                                           </span>
                                                    </OverlayTrigger>
                                                 &nbsp;&nbsp;
                                                    <OverlayTrigger placement = "top"
                                                         overlay={<Tooltip id="top" style={{fontSize:16, borderTopColor: "transparent"}}>Delete Day</Tooltip>}
                                                    >
                                                           <span className = "createMonthViewDay_deleteBox"
                                                                 onClick={(e) => {e.stopPropagation(); that.props.deleteDay(week_id, day_id)}}>
                                                                    <FontAwesomeIcon icon={faTimes}
                                                                                     className = "createMonthViewDay_faTimes"/>

                                                                    <FontAwesomeIcon icon={faCircle}
                                                                                     className = "createMonthViewDay_faCircle2"/>
                                                           </span>
                                                     </OverlayTrigger>

                                             </span>
                                         </div>
                                         { /*}<div className="monthViewDayCardContainer">
                                             {/*}<div className="monthViewDayCardHeader">
                                                 DAY { day_num }
                                             </div>/ }
                                             <span style={{position:"relative", left:"-40px"}}>
                                                      { /*}<span style={{position:"relative", left:"176px", top:"14px"}}>
                                                            <span className = "createMonthViewDay_copyBox"
                                                                  onClick={(e) => {e.stopPropagation(); that.props.duplicateDay(week_id, day_id, days.length)}}>
                                                                   <FontAwesomeIcon icon={faCopy}
                                                                                    className = "createMonthViewDay_faCopy"/>

                                                                   <FontAwesomeIcon icon={faCircle}
                                                                                    className = "createMonthViewDay_faCircle"/>
                                                            </span>
                                                          &nbsp;&nbsp;
                                                            <span className = "createMonthViewDay_deleteBox"
                                                                  onClick={(e) => {e.stopPropagation(); that.props.deleteDay(week_id, day_id)}}>
                                                                     <FontAwesomeIcon icon={faTimes}
                                                                                      className = "createMonthViewDay_faCopy"/>

                                                                     <FontAwesomeIcon icon={faCircle}
                                                                                      className = "createMonthViewDay_faCircle2"/>
                                                            </span>
                                                      </span>
                                                      { /*}<span className="glyphicon glyphicon-duplicate pull-right weekMainSingleDayEditIcons1"
                                                            onClick={(e) => {e.stopPropagation(); that.props.duplicateDay(week_id, day_id, days.length)}}
                                                      />
                                                      <span className="glyphicon glyphicon-remove pull-right weekMainSingleDayEditIcons2"
                                                            onClick={(e) => {e.stopPropagation(); that.props.deleteDay(week_id, day_id)}}
                                                      /> */ }
                                                      { /*}<span className="weekMainSingleDayEditIcons3pos"
                                                            onClick   = {(e) => {e.stopPropagation()}}>
                                                              <DropdownButton bsSize    = "large"
                                                                              pullRight
                                                                              /*onSelect={(event) => this.onSelect(event)}
                                                                              title     = "..."
                                                                              className = "glyphicon glyphicon-option-horizonta pull-right weekMainSingleDayEditIcons3"
                                                                              onClick   = {(e) => {e.stopPropagation()}}
                                                                              style     = {{fontSize:45, border:0, backgroundColor: "#fff"}}
                                                                              id        = "dropdown-size-large">
                                                                    <MenuItem className="dropdownMenuItem"
                                                                                onClick={(e) => {e.stopPropagation(); that.props.addNewDayFromMonthView(week_id, total_week_days)}}>
                                                                        <span className = "glyphicon glyphicon-plus yellowColor"
                                                                              //onClick={(e) => {e.stopPropagation(); that.props.addNewDayFromMonthView(week_id, total_week_days)}}
                                                                        /> &nbsp;
                                                                        Add Day
                                                                    </MenuItem>
                                                                    <MenuItem divider />
                                                                    <MenuItem className="dropdownMenuItem"
                                                                                onClick={(e) => {e.stopPropagation(); that.props.duplicateDay(week_id, day_id, days.length)}}>
                                                                        <span className = "glyphicon glyphicon-duplicate yellowColor"
                                                                              //onClick={(e) => {e.stopPropagation(); that.props.addNewDayFromMonthView(week_id, total_week_days)}}
                                                                        /> &nbsp;
                                                                        Duplicate Day
                                                                    </MenuItem>
                                                                    <MenuItem divider />
                                                                <MenuItem className="dropdownMenuItem"
                                                                                onClick={(e) => {e.stopPropagation(); that.props.deleteDay(week_id, day_id)}}>
                                                                        <span className = "glyphicon glyphicon-remove yellowColor"
                                                                              //onClick={(e) => {e.stopPropagation(); that.props.addNewDayFromMonthView(week_id, total_week_days)}}
                                                                        /> &nbsp;
                                                                        Delete Day
                                                                    </MenuItem>
                                                              </DropdownButton>
                                                    </span>
                                              </span>
                                          </div>*/ }

                                          { /*}<div className="weekMainSingleDayAddBlock"
                                               style={{position:"absolute",top:y_pos_addBlock_btn}}
                                               onClick={(e) => {e.stopPropagation(); that.props.addNewBlockToMonthView(day_id)}}>
                                              <span className="glyphicon glyphicon-plus orangeIcon"/>
                                          &nbsp; Add Block ???
                                          </div>*/ }
                                </div>
                                <div className="weekMainSingleDayBlocks">
                                        <CreateMonthViewDayBlockRow className         = "trackMonthViewDay"
                                                                    setModalAlertProps = {that.props.setModalAlertProps}
                                                                    showDayModalSimple = {that.props.showDayModalSimple}
                                                                    openAddNewExerciseModal = {that.openAddNewExerciseModal}
                                                                    editMonthViewExercise   = {that.editMonthViewExercise}
                                                                    getProgramDOMTree  = {that.getProgramDOMTree}
                                                                    block_data         = {parent_arr}
                                                                    day_id             = {day_id}
                                                                    day_num            = {day_num}
                                                                    current_week       = {current_week}
                                                                    duplicateBlock     = {that.duplicateBlock}
                                                                    deleteBlock        = {that.deleteBlock}
                                                                    updateBlockData    = {that.updateBlockData}
                                                                    checkNumberOfBlocksInDay = {that.checkNumberOfBlocksInDay}
                                        />
                                </div>
                    </span>
                    <span style={{display: "inline-block", width:15}}>
                        { /* THIS IS USED AS SPACING BETWEEN THE DAY CARDS */ }
                    </span>
                    { card_overlay }
            </React.Fragment>
        })
        var day_lgth = Object.keys(total_days).length;

        var empty_box_height = 339;
        var empty_box_xpos   = 325 * day_lgth;

        var week_box_height    = this.props.week_box_height;

        if(week_box_height === 720) {
            empty_box_height = 630;
        } else if(week_box_height === 560) {
            empty_box_height = 470;
        } else if(week_box_height === 400) {
            empty_box_height = 300;
        }

        var add_day_card = <div style={{cursor: "pointer", position:"absolute", top:"52px", left: empty_box_xpos, width:"305px", height: empty_box_height, border:"4px dashed #bbb"}}
                                 onClick={(e) => {e.stopPropagation(); that.props.addNewDayFromMonthView(week_id, total_week_days)}}>
                                <div style={{position:"relative", top:"45%", textAlign:"center", fontSize:"21px", fontWeight:"bold", color:"#888"}}>
                                    <FontAwesomeIcon icon={faPlus} size='1x'/> ADD DAY
                                </div>
                            </div>

        if(day_lgth === 7) add_day_card = ""; // if there are 7 day cards, removed "+ Add Day Card"

        var sortableDays = <span style={{display:"block", height:"100%", width:"100%", backgroundColor:"#efefef"}}>
                                <Sortable
                                        className="trackDayBox"

                                        options={{
                                            group: "days",
                                            sort: true,
                                			animation: 150,
                                            // not useable: onStart: (evt) => { },
                                            onEnd: (evt) => {
                                                /*var itemEl = evt.item;   // dragged HTMLElement
                                                var evt_to = evt.to;     // not useable
                                                var evt_from = evt.from; // not useable
                                                // gives incorrect values (don't use): var evt_old_index = evt.oldIndex;  // element's old index within old parent
                                                // gives incorrect values (don't use):var evt_new_index = evt.newIndex;  // element's new index within new parent

                                                /*var list = document.getElementsByClassName("trackBlockBox");
                                                //console.log("List: " +   list.length);
                                                var blocks_order_arr        = [];

                                                var blocks_exercs_order_arr = [];
                                                for (var i = 0; i < list.length; i++) {
                                                    console.log(list[i]);
                                                    var child_lgth = list[i].children.length;
                                                    for (var j = 0; j < child_lgth; j++) {
                                                        var tmp_block_id = list[i].children[j].attributes.getNamedItem("block_id").value;
                                                        blocks_order_arr.push(tmp_block_id);
                                                    }
                                                }

                                                for (var i = 0; i < list.length; i++) {
                                                    var child_lgth = list[i].children.length;
                                                    for (var j = 0; j < child_lgth; j++) {
                                                        var tmp_block_id = list[i].children[j].attributes.getNamedItem("block_id").value;
                                                        blocks_order_arr.push(tmp_block_id);
                                                        //if(child_lgth > 0)
                                                        //    blocks_exercs_order_arr.push([tmp_block_id, exercise_order_arr])
                                                    }
                                                }*/

                                                this.getProgramDOMTree()
                                            },
                                        }}

                                        /*onChange={(days_order, sortable, evt) => {
                                                console.log("=========== On Sort DAY =========");
                                                var day_to_index = evt.newIndex;
                                                var day_from_index = evt.oldIndex;

                                                var new_day_id = evt.item.children[0].attributes.getNamedItem("day_id").value;
                                                var day_id_from = evt.from.children[0].attributes.day_id.value;
                                                var day_id_to   = evt.to.children[0].attributes.day_id.value;

                                                var day_direction_right = true;
                                                //var week_id_from = evt.from.children[day_from_index].attributes.week_id.value;
                                                //var week_id_to = evt.to.children[day_to_index].attributes.week_id.value;

                                                //var week_order = evt.item.children[0].attributes.getNamedItem("week_num").value;
                                                var week_order_from = evt.from.children[0].attributes.week_num.value;
                                                var week_order_to   = evt.to.children[0].attributes.week_num.value;

                                                var new_week_id = evt.item.children[0].attributes.getNamedItem("week_id").value;

                                                console.log("days_order: " + days_order);
                                                var week_id_from = evt.from.children[0].attributes.week_id.value;
                                                var week_id_to   = evt.to.children[0].attributes.week_id.value;
                                        }}*/
                                >
                                    {total_days}
                                </Sortable>
                                { add_day_card }
                            </span>

        return sortableDays;
    }
}



// WEBPACK FOOTER //
// ./src/screens/program/CreateMonthViewDay.js